import script from "./filterPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./filterPopover.vue?vue&type=script&setup=true&lang=js"

import "./filterPopover.vue?vue&type=style&index=0&id=36e8a450&lang=scss"

const __exports__ = script;

export default __exports__